import { Chip, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import Timeline, { DateHeader, SidebarHeader, TimelineHeaders, TimelineMarkers, TodayMarker } from 'react-calendar-timeline';
import './LocationTimeline.css';
import moment from 'moment-timezone';
import { getLocationsByUnit } from 'services/location';
import { getEvents } from 'services/user-events';
import { getUnits } from 'services/unit';
import HeaderLeft from './../../../assets/images/timeline_header_left.png';
import HeaderRight from './../../../assets/images/timeline_header_right.png';
import HeaderLogo from './../../../assets/images/timeline_header_logo.png';

const LocationTimeline = () => {
    const [unit, setUnit] = useState({});

    const [units, setUnits] = useState([]);
    const [locations, setLocations] = useState([]);
    const [events, setEvents] = useState([]);

    const timezone = 'America/Sao_Paulo';

    const visibleTimeStart = moment.tz(timezone).hour(6).minute(0);
    const visibleTimeEnd = moment.tz(timezone).hour(20).minute(0);

    const fetchUnits = async () => {
        getUnits().then((resp) => {
            setUnit({});
            setUnits(resp.data.data);
        });
    };

    const fetchLocations = async () => {
        if (unit?.id) {
            getLocationsByUnit(unit.id).then((resp) => {
                setLocations(
                    [...resp.data.data].map((location) => ({
                        id: location.id,
                        title: location.description,
                        floor: location.floor
                    }))
                );
            });
        }
    };

    const fetchEvents = async () => {
        getEvents(moment.tz(timezone).format('YYYY-MM-DD')).then((resp) => {
            setEvents(
                [...resp.data].map((event) => ({
                    id: event.id,
                    group: event.location_id,
                    title: event.title + (event.owner?.name ? ` - ${event.owner.name}` : ''),
                    start_time: moment.tz(event.start, timezone),
                    end_time: moment.tz(event.end, timezone),
                    className: event.checked_at ? 'item-checked' : 'item-unchecked'
                }))
            );
        });
    };

    useEffect(() => {
        const interval = setInterval(() => {
            fetchEvents();
        }, 20000);
        return () => clearInterval(interval);
    }, [events]);

    useEffect(() => {
        if (units.length > 0) {
            setUnit(units[0]);
        }
    }, [units]);

    useEffect(() => {
        fetchLocations();
        fetchEvents();
    }, [unit]);

    useEffect(() => {
        fetchUnits();
    }, []);

    return (
        <>
            <Grid container display="flex" justifyContent="space-between" spacing={0}>
                <Grid item sm={4} display={{ xs: 'none', sm: 'block' }}>
                    <Stack
                        sx={{
                            height: 300,
                            width: '100%',
                            display: 'block',
                            backgroundImage: `url(${HeaderLeft})`,
                            backgroundPositionX: 'left',
                            backgroundRepeat: 'no-repeat'
                        }}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Stack display="flex" justifyContent="center" alignItems="center" spacing={1} sx={{ pt: 2 }}>
                        <img src={HeaderLogo} alt="Jope - ISB" height={200} />
                        <FormControl required fullWidth style={{ flex: '1' }}>
                            <InputLabel id="unit-label">Unidade</InputLabel>
                            <Select
                                labelId="unit-label"
                                label="Unidade"
                                value={unit}
                                onChange={(e) => setUnit(e.target.value)}
                                renderValue={(value) => value.description}
                            >
                                {units?.map((unit) => (
                                    <MenuItem key={unit.id} value={unit}>
                                        {unit.description}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                </Grid>
                <Grid item sm={4} display={{ xs: 'none', sm: 'block' }}>
                    <Stack
                        sx={{
                            height: 300,
                            width: '100%',
                            display: 'block',
                            backgroundImage: `url(${HeaderRight})`,
                            backgroundPositionX: 'right',
                            backgroundRepeat: 'no-repeat'
                        }}
                    />
                </Grid>
            </Grid>
            {visibleTimeStart && visibleTimeEnd && (
                <Timeline
                    groups={locations}
                    items={events}
                    defaultTimeStart={visibleTimeStart}
                    defaultTimeEnd={visibleTimeEnd}
                    buffer={1}
                    canMove={false}
                    canResize={false}
                    canChangeGroup={false}
                    sidebarWidth={280}
                    lineHeight={40}
                    groupRenderer={({ group }) => {
                        return (
                            <Stack display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ px: 1 }}>
                                <Typography variant="label">{group.title}</Typography>
                                <Typography variant="legend" sx={{ fontSize: 'medium', color: '#777' }}>
                                    {group.floor}
                                </Typography>
                            </Stack>
                        );
                    }}
                    scrollRef={() => {}}
                >
                    <TimelineHeaders>
                        <SidebarHeader>
                            {({ getRootProps }) => {
                                return (
                                    <Stack
                                        {...getRootProps()}
                                        justifyContent={'center'}
                                        alignItems={'center'}
                                        sx={{ border: '1px solid #BBB' }}
                                    >
                                        <Typography variant="h5" sx={{ color: 'white', fontSize: 'large' }}>
                                            JOPE ISB - Open Space
                                        </Typography>
                                    </Stack>
                                );
                            }}
                        </SidebarHeader>
                        <DateHeader unit="primaryHeader" labelFormat={'dddd, LL'} />
                        <DateHeader labelFormat={'HH:mm'} />
                    </TimelineHeaders>
                    <TimelineMarkers>
                        <TodayMarker interval={10000}>
                            {({ styles }) => {
                                const customStyles = {
                                    ...styles,
                                    backgroundColor: 'red',
                                    width: 1
                                };
                                return <div style={customStyles} />;
                            }}
                        </TodayMarker>
                    </TimelineMarkers>
                </Timeline>
            )}
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
                <Chip label="Reservado" style={{ backgroundColor: '#12a9a2', color: 'white', fontSize: 'large', fontWeight: 500 }} />
                <Chip label="Ocupado" style={{ backgroundColor: '#6f3b8c', color: 'white', fontSize: 'large', fontWeight: 500 }} />
            </Stack>
        </>
    );
};

export default LocationTimeline;
